import templateUrl from 'emun.swatch/swatchcount-list-cards.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

let component = {
    bindings: {
    },
    require: {
        container: '^swatchContainer',
        list: '^swatchCounts'
    },
    controller() {
        basicController(this);
        //this.query = this.list.query;
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;